import { useTranslation } from "react-i18next";
import styles from "./StatusMessage.module.css";

const ICONS = {
  // 달력
  empty: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <rect x="3.5" y="5" width="17" height="15" rx="2.5" />
      <path d="M3.5 10h17M8 3v4M16 3v4" strokeLinecap="round" />
    </svg>
  ),
  // 돋보기
  search: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <circle cx="11" cy="11" r="6.5" />
      <path d="M16 16l4.5 4.5" strokeLinecap="round" />
    </svg>
  ),
  // 느낌표
  error: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7.5v5.5M12 16.5v.01" strokeLinecap="round" />
    </svg>
  ),
};

// 불러오는 중·경기 없음·검색 결과 없음·오류 안내 (관리자 StatusMessage와 같은 모양, 한국어/영어)
// type: "loading" | "empty" | "search" | "error"
const StatusMessage = ({ type = "empty", title, description }) => {
  const { t } = useTranslation();
  const defaults = {
    loading: { title: t("status.loading") },
    empty: { title: t("status.empty-title"), description: t("status.empty-desc") },
    search: { title: t("status.search-title"), description: t("status.search-desc") },
    error: { title: t("status.error-title") },
  };
  const text = defaults[type] || {};
  return (
    <div className={`${styles.status} ${styles[type] || ""}`}>
      {type === "loading" ? (
        <span className={styles.spinner} />
      ) : (
        <span className={styles.icon}>{ICONS[type]}</span>
      )}
      <p className={styles.title}>{title || text.title}</p>
      {(description || text.description) && (
        <p className={styles.description}>{description || text.description}</p>
      )}
    </div>
  );
};
export default StatusMessage;
